// extracted by mini-css-extract-plugin
export default {"wrapper":"user-search-filter_wrapper__8hFMj","inputContainer":"user-search-filter_inputContainer__ioZXr"};